import React from 'react';

const Services = () => {
  const services = [
    {
      icon: 'fas fa-home',
      title: 'Residential Fiber',
      description: 'High-speed fiber internet for homes with speeds up to 1000 Mbps for streaming, gaming, and smart home devices.',
      features: ['Up to 1000 Mbps', 'No Data Caps', 'Professional Installation']
    },
    {
      icon: 'fas fa-building',
      title: 'Business Solutions',
      description: 'Enterprise-grade fiber connectivity with dedicated bandwidth and priority support for businesses of all sizes.',
      features: ['Dedicated Bandwidth', 'SLA Guarantee', '24/7 Support']
    },
    {
      icon: 'fas fa-tools',
      title: 'Installation Services',
      description: 'Professional fiber optic cable installation by certified technicians with minimal disruption to your property.',
      features: ['Certified Technicians', 'Same-Day Service', 'Clean Installation']
    },
    {
      icon: 'fas fa-wrench',
      title: 'Maintenance & Repair',
      description: 'Comprehensive maintenance and rapid repair services to ensure your fiber connection stays reliable and fast.',
      features: ['24/7 Monitoring', 'Quick Response', 'Preventive Maintenance']
    },
    {
      icon: 'fas fa-route',
      title: 'Network Design',
      description: 'Custom fiber network design and planning for developments, campuses, and large-scale infrastructure projects.',
      features: ['Custom Design', 'Scalable Solutions', 'Future-Proof Planning']
    },
    {
      icon: 'fas fa-headset',
      title: 'Technical Support',
      description: 'Expert technical support and customer service to help you get the most out of your fiber internet connection.',
      features: ['24/7 Support', 'Remote Diagnostics', 'Expert Technicians']
    }
  ];

  return (
    <section id="services" className="services">
      <div className="container">
        <div className="section-header">
          <h2>Our Fiber Optic Services</h2>
          <p>Complete fiber solutions for homes and businesses</p>
        </div>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                <i className={service.icon}></i>
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, idx) => (
                  <li key={idx}>
                    <i className="fas fa-check"></i>
                    {feature}
                  </li>
                ))}
              </ul>
              <button className="btn btn-outline">Get Quote</button>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;